// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[class*="MuiToolbar-root-"] div[class*="css-glamorous-div-"] h2,
div[class*="MuiToolbar-root-"] div[class*="css-glamorous-div-"] svg[class*="MuiSvgIcon-root-"] {
  display: none; }

.warrantyTable th {
  font-size: 14px !important;
  text-transform: capitalize; }

.warrantyTable button[class*="MuiButton-raised-"]:after {
  content: 'Lagre'; }

.warrantyTable button[class*="MuiButton-raised-"] span[class*="MuiButton-label-"] {
  display: none; }

.react-datepicker__close-icon {
  top: 25%;
  right: 7px;
  width: 16px;
  height: 16px !important;
  position: absolute; }

.react-datepicker__close-icon::after {
  right: 0 !important;
  top: 0;
  margin: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/no/motorgruppen/warrantyPeriod/WarrantyPeriod.scss"],"names":[],"mappings":"AAAA;;EAIM,aAAa,EAAA;;AAKnB;EAEI,0BAA0B;EAC1B,0BAA0B,EAAA;;AAH9B;EAQM,gBAAgB,EAAA;;AARtB;EAYM,aAAa,EAAA;;AAKnB;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB,EAAA;;AAEpB;EACE,mBAAmB;EACnB,MAAM;EACN,SAAS,EAAA","sourcesContent":["div[class*=\"MuiToolbar-root-\"] {\n  div[class*=\"css-glamorous-div-\"] {\n    h2,\n    svg[class*=\"MuiSvgIcon-root-\"] {\n      display: none;\n    }\n  }\n}\n\n.warrantyTable {\n  th {\n    font-size: 14px !important;\n    text-transform: capitalize;\n  }\n\n  button[class*=\"MuiButton-raised-\"] {\n    &:after {\n      content: 'Lagre';\n    }\n\n    span[class*=\"MuiButton-label-\"] {\n      display: none;\n    }\n  }\n}\n\n.react-datepicker__close-icon {\n  top: 25%;\n  right: 7px;\n  width: 16px;\n  height: 16px !important;\n  position: absolute;\n}\n.react-datepicker__close-icon::after {\n  right: 0 !important;\n  top: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
